import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.reduce.js";
/**
 * 本地 SVG sprite 映射工具。
 * 图标文件由 scripts/build-comment-action-sprite.js 合并到 public/comment-actions-sprite.svg。
 */
import authAuthorizedIcon from "./comment-actions/已授权.svg";
import authUnauthorizedIcon from "./comment-actions/未授权.svg";
import { SPRITE_VERSION } from "./.sprite-version.js";

// sprite 内容变更后通过 query 更新缓存，避免浏览器继续使用旧版黑色图标。
// SPRITE_VERSION 由 build-comment-action-sprite.js 根据 sprite 内容自动生成。
export const COMMENT_ACTION_SPRITE_URL = `/comment-actions-sprite.svg?v=${SPRITE_VERSION}-fill-none`;
const COMMENT_ACTION_SPRITE_DOM_ID = "comment-actions-sprite-container";
let commentActionSpritePromise = null;
export const externalImageIconUrls = {
  // 授权状态 SVG 文件内嵌大体积 base64 图片，按需作为 img 加载，不放进公共 sprite。
  "已授权": authAuthorizedIcon,
  "未授权": authUnauthorizedIcon,
  // AccountDetail 使用英文别名控制授权状态，别名也要直连授权 SVG，避免回退成默认图标。
  authAuthorized: authAuthorizedIcon,
  authUnauthorized: authUnauthorizedIcon
};
const getIconHash = name => {
  // 与 sprite 生成脚本保持一致，确保中文、空格图标名也能生成稳定 symbol id。
  return Array.from(name).reduce((hash, char) => hash * 31 + char.charCodeAt(0) >>> 0, 0).toString(36);
};
export const createCommentActionIconSymbolId = (name, inheritColor = true) => {
  // symbol id 规则必须和 scripts/build-comment-action-sprite.js 同步。
  const normalizedName = String(name).trim().replace(/[^A-Za-z0-9_-]+/g, "-").replace(/^-+|-+$/g, "");
  return `local-svg-${inheritColor ? "inherit" : "original"}-${normalizedName || "icon"}-${getIconHash(name)}`;
};
export const getCommentActionIconHref = (name, inheritColor = true) => {
  return `#${createCommentActionIconSymbolId(name, inheritColor)}`;
};
export const ensureCommentActionSprite = () => {
  // 外链 sprite 中的 currentColor 在部分浏览器不会继承页面颜色，注入当前 DOM 后才能正常跟随菜单色。
  if (typeof document === "undefined") return Promise.resolve();
  if (document.getElementById(COMMENT_ACTION_SPRITE_DOM_ID)) return Promise.resolve();
  if (!commentActionSpritePromise) {
    commentActionSpritePromise = fetch(COMMENT_ACTION_SPRITE_URL).then(response => {
      // 非 2xx 响应不注入错误页面；失败后由 catch 清空 Promise，让后续图标可以重新请求。
      if (!response.ok) {
        throw new Error(`加载评论操作图标失败：${response.status}`);
      }
      return response.text();
    }).then(spriteContent => {
      if (document.getElementById(COMMENT_ACTION_SPRITE_DOM_ID)) return;
      const container = document.createElement("div");
      container.id = COMMENT_ACTION_SPRITE_DOM_ID;
      container.style.display = "none";
      container.innerHTML = spriteContent;
      // 启动阶段预热可能早于 body 创建，回退至 documentElement 保证可安全注入。
      const mountTarget = document.body || document.documentElement;
      mountTarget.insertBefore(container, mountTarget.firstChild);
    }).catch(error => {
      // 共享请求失败时释放锁，避免一次临时网络异常导致整个会话永久无法加载图标。
      commentActionSpritePromise = null;
      throw error;
    });
  }
  return commentActionSpritePromise;
};
export const getCommentActionIconSource = (name, inheritColor = true) => {
  // 大体积图片图标不进入公共 sprite，避免任意页面首次渲染菜单时下载授权图。
  if (externalImageIconUrls[name]) {
    return {
      type: "image",
      url: externalImageIconUrls[name]
    };
  }
  return {
    type: "sprite",
    href: getCommentActionIconHref(name, inheritColor)
  };
};
export default {
  COMMENT_ACTION_SPRITE_URL,
  externalImageIconUrls,
  createCommentActionIconSymbolId,
  getCommentActionIconHref,
  getCommentActionIconSource,
  ensureCommentActionSprite
};